export const ID_PREFIX = {
  EPOCH: "cg_epoch_",
  GRID_EPOCH: "cg_gridepoch_",
  LOG_ENTRY: "cg_logentry_",
} as const;
